module.exports = __webpack_public_path__ + "images/help_v2/video-play-83f8af2aa03ae79bc7b40cddcd845c20.png";